import React, { Fragment, useState } from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { t } from 'Src/i18n';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import { Tabs } from 'Components/frameworks/tabs/Tabs';
import { EasyArrivalModal } from 'Components/widgets/easy-arrival-modal/EasyArrivalModal';
import { Hero } from 'Components/widgets/hero/Hero';
import { RentalsFilteredList } from 'Components/widgets/rentals-filtered-list/RentalsFilteredList';
import { sortCategoryOnDemandActivitiesByStartingPrice } from 'Components/utils/activities/activities.utils';

const getCols = (isDesktop, isTablet) => {
  if (isDesktop) {
    return 3;
  }

  if (isTablet) {
    return 2;
  }

  return 1;
};

type Props = {
  image: string;
  rentalsTree: RentalsTree;
};
export const LayerRentalsBody = ({ image, rentalsTree = [] }: Props) => {
  const { isDesktop, isTablet } = useResponsive();
  const [overHeight, setOverHeight] = useState(0);
  const [isOpen, setIsOpen] = useState(true);

  const getOverHeight = (height) => {
    setOverHeight(height);
  };

  if (!rentalsTree?.length) {
    return null;
  }

  const cols = getCols(isDesktop, isTablet);
  const items = rentalsTree
    .filter((useCase) => !!useCase.items.length)
    .map((useCase) => ({
      header: {
        title: useCase.label,
      },
      headerId: useCase.id,
      panelId: `panel-${useCase.id}`,
      content: useCase.items
        .filter((type) => !!type.items.length)
        .map((type) => (
          <RentalsFilteredList
            className="my-40"
            colsNumber={cols}
            id={type.id}
            key={type.id}
            rentals={sortCategoryOnDemandActivitiesByStartingPrice(type.items)}
            title={type.label}
          />
        )),
    }));
  return (
    <Fragment>
      <Hero className="bg-darkGrey" size="medium" url={image} />
      <SiteContainer
        className="py-40 pb-100"
        style={{
          ...(overHeight && {
            paddingBottom: overHeight + 130,
          }),
        }}
      >
        <Tabs
          id="rentals"
          isContentUnmountedOnCollapse
          isScrollable
          items={items}
          scrollBackwardLabel={t('common.scrollBackward')}
          scrollForwardLabel={t('common.scrollForward')}
          message={t('booking.activities.rentals.priceAndAvailibiltyInformations')}
        />
        {isOpen && (
          <EasyArrivalModal
            className="fixed bottom-0 left-1/2 z-1 mb-20 -translate-x-1/2 transform"
            getOverHeight={getOverHeight}
            onEasyArrivalModalClose={() => setIsOpen(false)}
          />
        )}
      </SiteContainer>
    </Fragment>
  );
};
